import {Component, EventEmitter, OnInit, ChangeDetectorRef} from '@angular/core';
import {VesselsService} from 'src/app/transportation/vessels/vessels.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentItem} from 'src/app/documents/document-item';
import {DocumentService} from 'src/app/documents/documents.service';
import {BlComponent} from './bl/bl.component';
import {NorComponent} from './nor/nor.component';
import {DischargeComponent} from 'src/app/transportation/vessels/voyage/discharge/discharge.component';
import {SofComponent} from 'src/app/transportation/vessels/voyage/sof/sof.component';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import {DateTimeHelpers} from 'src/app/shared/helpers/date-time.helpers';
import {KeycloakService} from 'src/app/authentication/keycloak.service';
import {forkJoin} from 'rxjs';
import {CommentComponent} from 'src/app/transportation/vessels/voyage/comment/comment.component';
import {MessageLevel, PgMessagesService} from 'src/app/shared/services/pg-messages.service';
import {MiscDocumentComponent} from './misc-document/misc-document.component';
import {saveAs} from 'file-saver';
import {VoyageToolbarComponent} from './voyage-toolbar/voyage-toolbar.component';
import _ from 'lodash';
import {
  PgSubTitleComponent,
  PgTitleComponent,
  PgToolbarComponent
} from '../../../shared/components/title-bar/title-bar.component';
import { ChartererComponent } from './charterer/charterer.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { Voyage, Discharge, BillOfLading } from 'src/app/generated/services/transportation/voyages/voyage';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

@Component({
  selector: 'app-voyage',
  templateUrl: './voyage.component.html',
  styleUrls: ['./voyage.component.css'],
  imports:[SharedModule]
})
export class VoyageComponent implements OnInit, PgTitleComponent, PgSubTitleComponent, PgToolbarComponent {
  subTitle: EventEmitter<string> = new EventEmitter();
  title: EventEmitter<string> = new EventEmitter();
  toolbarComponentType = VoyageToolbarComponent;
  toolbarComponent!: VoyageToolbarComponent;
  selectedVoyage?: Voyage;
  expectedVersion: number = 0;
  showTabs: boolean = true;
  canSkipDocumentUpload: boolean = false;

  selectedDocumentType: string | null = null;
  uploadedFileId: string | null = null;

  organisations: Organisation[] = [];
  allSofItems: string [][] = [];
  ports: Organisation[] = [];
  volumes: any;

  calculateLaytime = VesselsService.calculateLaytime;
  calculateBerthTime = VesselsService.calculateBerthTime;
  voyageLengthFromLoadingToDischarge = VesselsService.voyageLengthFromLoadingToDischarge;

  providers =  [
    new DocumentItem(BlComponent, 'Bill of Lading', ''),
    new DocumentItem(NorComponent, 'NOR', ''),
    new DocumentItem(SofComponent, 'SOF', ''),
    new DocumentItem(DischargeComponent, 'Discharge', ''),
    new DocumentItem(CommentComponent, 'Comment', ''),
    new DocumentItem(MiscDocumentComponent, 'Misc-Document', ''),
    new DocumentItem(ChartererComponent, 'Charterer', ''),
  ];

  constructor(private _documentsService: DocumentService,
              private _activatedRoute: ActivatedRoute,
              private _organisationService: OrganisationService,
              private _pgMessagesService: PgMessagesService,
              private _keycloakService: KeycloakService,
              private _router: Router,
              private cdr: ChangeDetectorRef,
              private _voyagesService: VoyageServiceSpa,
              private _lookUpServiceSpa: LookupServiceSpa,) {
    this.selectedVoyage = Voyage.create();
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  ngOnInit() {
    this._activatedRoute.paramMap.subscribe(p => {
      forkJoin([
        this._voyagesService.getVoyageById({ id: p.get('id') || ''}),
        this._lookUpServiceSpa.getLookupItems({ categoryName: 'voyage_sof_all' }),
        this._organisationService.getPorts(),
        this._organisationService.get()
      ]).subscribe(results => {
        this.toolbarComponent.addDocument.subscribe(addRequest => {
          this.showAddDocument(addRequest);
          this.cdr.detectChanges();
        });
        this.selectedVoyage = results[0].data;
        this.expectedVersion = results[0].version;
        this.allSofItems = results[1].items.map(item => item.values);
        this.ports = results[2];
        this.organisations = results[3];
        this.selectedVoyage?.sofs.forEach(sof  => {
          sof.entries = sof.entries.sort((s1, s2) => s1.timestamp - s2.timestamp);
        });
        this.volumes = this.calculateVolumes();
        this.title.emit(this.selectedVoyage?.vesselName);
        const agentVoyageNo = (this.selectedVoyage?.agentVoyageNo) ? '(' + this.selectedVoyage?.agentVoyageNo + ')' : '';
        this.subTitle.emit(`${this.selectedVoyage?.shipVoyageNo} ${agentVoyageNo}`);
        this.toolbarComponent.currentVoyageId = this.selectedVoyage?.id || '';
        this.selectedDocumentType = p.get('docType');
        if(this.selectedDocumentType) {
          this.showTabs = false;
        }
        this.uploadedFileId = p.get('fileId');
        this.cdr.markForCheck();
      });
    });
  }

  findNorLocations(norType: string) {
    const loadingNors = this.selectedVoyage?.nors.filter(n => n.norType === norType);
    if (loadingNors && loadingNors.length > 0) {
      return loadingNors.map(n => this.findOrganisation(n.portOrganisationId));
    }
  }

  showAddDocument(documentType: string) {
    this._router.navigate(['/vessels/voyage/', this.selectedVoyage?.id, documentType]);
  }

  routToDocument(documentType: string, fileId: string) {
    this._router
      .navigate(
        ['/vessels/voyage/', this.selectedVoyage?.id, documentType], {
          queryParams: {
            fileId:fileId,
          }
        }
      );
  }

  showTabsToggle() {
    this.showTabs = true;
  }

  formatDate(dt: number, portOrganisationId: string) {
    if (this.ports) {
      const selectedTimezone = this._organisationService.getOrganisationTimezone(portOrganisationId, this.ports);
      if (selectedTimezone) {
        return DateTimeHelpers.getDateFromTimestamp(selectedTimezone, dt);
      } else {
        console.error(`Cannot find timezone for organisation Id: ${portOrganisationId}`);
      }
    }
  }

  formatProducts(bl: BillOfLading) {
    return bl.products
      .map(p => `${p.product}: ${Number(p.grossWeight).toFixed(3)}`)
      .join(', ');
  }

  findOrganisation(organisationId: string) {
    if (this.organisations) {
      const organisation = this.organisations.find(p => p.name === organisationId);
      if (organisation) {
        return organisation.nameTranslations['en'];
      } else {
        return 'not found';
      }
    }
  }

  downloadFile(fileId: string, prefix: string) {
    this._documentsService.download(fileId).subscribe(b => {
      saveAs(b.body, `${prefix}_${fileId}.pdf`);
    }, () => {
      this._pgMessagesService.publishMessage({
        message: 'Could not download this file.',
        level: MessageLevel.Error,
        topic: 'Voyage document'
      });
    });
  }

  calculateVolumes() {
    const sumOfRevise = (this.selectedVoyage?.billOfLadings) ?
      _.chain(this.selectedVoyage?.billOfLadings.filter(bill => bill.revise === true).flatMap(b => b.products))
        .groupBy(b => b.product)
        .map((v, k) => {
          const grossWeight = v.reduce((x, y) => x + y.grossWeight, 0);
          return {
            product: k,
            grossWeight
          };
        }).value() : null;

    const sumOfReal = (this.selectedVoyage?.billOfLadings) ?
      _.chain(this.selectedVoyage?.billOfLadings.filter(bill => bill.revise !== true).flatMap(b => b.products))
        .groupBy(b => b.product)
        .map((v, k) => {
          const grossWeight = v.reduce((x, y) => x + y.grossWeight, 0);
          return {
            product: k,
            grossWeight
          };
        }).value() : null;

    const dischWeight = (this.selectedVoyage?.discharges) ?
      _.chain(this.selectedVoyage?.discharges.flatMap(dch => dch.measurements.filter(f => f.primary === true)))
        .groupBy(d => d.product)
        .map((v, k) => {
          const weight = v.reduce((x, y) => x + (y.weight ?? 0), 0);
          return {
            product: k,
            weight
          };
        }).value() : null;

    const productDiffs = (dischWeight && sumOfReal) ?
      dischWeight.map(d => {
        const load = sumOfReal.find(b => b['product'] === d['product']);
        let productDiff = null;
        if (load) {
          productDiff = d['weight'] - load['grossWeight'];
        }
        return {
          product: d['product'],
          diff: productDiff
        };
      }) : null;

    const totalLoading = sumOfReal?.map(p => p.grossWeight).reduce((x, y) => x + y, 0);
    const totalDischarge = dischWeight?.map(p => p.weight).reduce((x, y) => x + y, 0);
    const allDifferences = (totalDischarge !== undefined && totalLoading !== undefined) ? totalDischarge - totalLoading : null;
    return {
      loadPorts: this.findNorLocations('loading'),
      dischargePorts: this.findNorLocations('discharging'),
      loadingRealWeight: sumOfReal,
      loadingReviseWeight: sumOfRevise,
      dischargeWeight: dischWeight,
      diff: productDiffs,
      allDiff: allDifferences,
      allLoading: totalLoading,
      allDischarging: totalDischarge,
      // noLoadingPorts: this._vesselsService.countPorts(this.selectedVoyage, 'loading'),
      // noDischargePorts: this._vesselsService.countPorts(this.selectedVoyage, 'discharge'),
      // timeBetweenLoadingDis: this.voyageLengthFromLoadingToDischarge(this.selectedVoyage),
      // loadingBerthTime: this.calculateBerthTime(this.selectedVoyage, 'loading'),
      // dischargeBerthTime: this.calculateBerthTime(this.selectedVoyage, 'discharge'),
      // loadingLaytime: this.calculateLaytime(this.selectedVoyage, 'loading'),
      // dischargeLaytime: this.calculateLaytime(this.selectedVoyage, 'discharge')
    };
  }

  containsPrimary(discharge: Discharge) {
    return discharge.measurements.find(m => m.primary);
  }

  sumDischarges(discharge: Discharge) {
    return _.chain(discharge.measurements.filter(f => f.primary === true))
      .groupBy(d => d.product)
      .map((v, k) => {
        const weight = v.reduce((x, y) => x + (y.weight ?? 0), 0);
        return {
          product: k,
          weight
        };
      }).value();
  }

  async deleteDocument<T extends { fileId?: string }>(documents: T[], document: T) {
    if (!confirm('Are you sure you want to delete this document from the voyage?')) {
      return;
    }

    const voyage = this.selectedVoyage;
    const index = documents.indexOf(document);
    if (index < 0 || !voyage) {
      return;
    }

    documents.splice(index, 1);
    try {
      await this._voyagesService.updateVoyage({
        data: voyage,
        expectedVersion: this.expectedVersion
      });
    } catch (error) {
      documents.splice(index, 0, document);
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Error,
        message: 'Could not delete this document from the voyage.',
        topic: 'Voyage document'
      });
      console.error('Could not delete voyage document', error);
      return;
    }

    this._pgMessagesService.publishMessage({
      level: MessageLevel.Info,
      message: `Deleted document from voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
      topic: 'Voyage'
    });
    this._router.navigate(['vessels/voyage', voyage.id], {
      queryParams: {
        t: new Date().getTime()
      }
    }).then();
  }
}